// Explicit tagged values keep Sets, undefined, Maps and binary uploads intact across HTTP.
export const encode = (value: any): any => {
	if (value === undefined) {
		return ["undefined"];
	}
	if (typeof value === "number" && !Number.isFinite(value)) {
		return ["number", String(value)];
	}
	if (value === null || typeof value !== "object") {
		return value;
	}
	if (value instanceof Set) {
		return ["set", [...value].map(encode)];
	}
	if (value instanceof Map) {
		return ["map", [...value].map(([k, v]) => [encode(k), encode(v)])];
	}
	if (value instanceof Date) {
		return ["date", value.toISOString()];
	}
	if (Array.isArray(value)) {
		return ["array", value.map(encode)];
	}
	return ["object", Object.entries(value).map(([k, v]) => [k, encode(v)])];
};
export const decode = (value: any): any => {
	if (!Array.isArray(value)) {
		return value;
	}
	const [tag, data] = value;
	if (tag === "undefined") {
		return undefined;
	}
	if (tag === "number") {
		return Number(data);
	}
	if (tag === "set") {
		return new Set(data.map(decode));
	}
	if (tag === "map") {
		return new Map(data.map(([k, v]: any[]) => [decode(k), decode(v)]));
	}
	if (tag === "date") {
		return new Date(data);
	}
	if (tag === "array") {
		return data.map(decode);
	}
	if (tag === "object") {
		return Object.fromEntries(data.map(([k, v]: any[]) => [k, decode(v)]));
	}
	throw new Error("Formato de transporte inválido");
};
